import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { CompanyBusinessTypeService } from './company-business-type.service';

/** Allows the route only when the active company's business_type matches `route.data.businessType`. */
@Injectable({ providedIn: 'root' })
export class BusinessTypeGuard {
  constructor(
    private businessTypeService: CompanyBusinessTypeService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const required = route.data?.['businessType'] as string | undefined;
    return this.businessTypeService.load().pipe(
      map(type => !required || type === required || this.router.createUrlTree(['/'])),
    );
  }
}
